import fetch from 'isomorphic-fetch';

export const ActionTypes = {
  REQUEST_CARDS: 'zola/cards/plp/REQUEST_CARDS',
  RECEIVE_CARDS: 'zola/cards/plp/RECEIVE_CARDS',
  REQUEST_MORE_CARDS: 'zola/cards/plp/REQUEST_MORE_CARDS',
  RECEIVE_MORE_CARDS: 'zola/cards/plp/RECEIVE_MORE_CARDS',
  LISTING_CARD_LOAD_MORE: 'zola/cards/plp/LISTING_CARD_LOAD_MORE',
  LISTING_CARD_ACTIVE_CHANGE: 'zola/cards/plp/LISTING_CARD_ACTIVE_CHANGE',
  LISTING_CARD_TYPE_CHANGE: 'zola/cards/plp/LISTING_CARD_TYPE_CHANGE',
  LISTING_CARD_COLORS_CHANGE: 'zola/cards/plp/LISTING_CARD_COLORS_CHANGE',
  LISTING_CARD_BOOLEAN_FILTER_CHANGE: 'zola/cards/plp/LISTING_CARD_BOOLEAN_FILTER_CHANGE',
  LISTING_RESET_FILTERS: 'zola/cards/plp/LISTING_RESET_FILTERS',
  LISTING_CARD_DETAIL_SKU_CHANGE: 'zola/cards/plp/LISTING_CARD_DETAIL_SKU_CHANGE',
  LISTING_ADMIN_VIEW: 'zola/cards/plp/LISTING_ADMIN_VIEW',
  UPDATE_LISTING_SEARCH_FILTERS: 'zola/cards/plp/UPDATE_LISTING_SEARCH_FILTERS',
};

export const updateCardActiveFilter = payload => ({
  type: ActionTypes.LISTING_CARD_ACTIVE_CHANGE,
  payload
});

export const updateCardTypeFilter = payload => ({
  type: ActionTypes.LISTING_CARD_TYPE_CHANGE,
  payload
});

export const updateCardColorFilters = payload => ({
  type: ActionTypes.LISTING_CARD_COLORS_CHANGE,
  payload
});

export const updateBoolFilter = payload => ({
  type: ActionTypes.LISTING_CARD_BOOLEAN_FILTER_CHANGE,
  payload
});

export const resetListingFilters = payload => ({
  type: ActionTypes.LISTING_RESET_FILTERS,
  payload
});

export const updateCardIndex = index => ({
  type: ActionTypes.LISTING_CARD_COLORS_CHANGE,
  index,
});

export const updateListingDetailActiveSku = (productId, skuId) => ({
  type: ActionTypes.LISTING_CARD_DETAIL_SKU_CHANGE,
  payload: {
    productId,
    skuId,
  }
});

export const updateListingAdminView = isAdminView => ({
  type: ActionTypes.LISTING_ADMIN_VIEW,
  payload: {
    isAdminView
  }
});

export function updateSearchFilters(key, value) {
  return {
    type: ActionTypes.UPDATE_LISTING_SEARCH_FILTERS,
    payload: { key, value }
  };
}

const requestCards = () => ({
  type: ActionTypes.REQUEST_CARDS
});

const receiveCards = json => ({
  type: ActionTypes.RECEIVE_CARDS,
  payload: json
});

const requestMoreCards = () => ({
  type: ActionTypes.REQUEST_MORE_CARDS
});

const receiveMoreCards = json => ({
  type: ActionTypes.RECEIVE_MORE_CARDS,
  payload: json
});


// cardType can be INVITATION or SAVE_THE_DATE
export const fetchCards = () => (
  (dispatch, getState) => {
    // console.log('fetchCards: ');
    dispatch(requestCards());
    const state = getState();
    const { filters } = state.cards.cardListing;
    // const cardType = state.cards.project.activeCardEvent === 'invitation' ? 'INVITATION' : 'SAVE_THE_DATE';
    const requestBody = {
      ...filters,
      // card_type: cardType,
      offset: 0
    };
    return fetch('/web-api/v1/card-product/search', {
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    })
    .then(response => response.json())
    .then(json => dispatch(receiveCards({ ...json, card_type: filters.card_type })))
    .catch(err => console.warn(err));
  }
);

export const fetchMoreCards = () => (
  (dispatch, getState) => {
    // console.log('fetchMoreCards: ');
    dispatch(requestMoreCards());
    const state = getState();
    const { filters } = state.cards.cardListing;
    // const cardType = state.cards.project.activeCardEvent === 'invitation' ? 'INVITATION' : 'SAVE_THE_DATE';
    const requestBody = {
      ...filters,
      // card_type: cardType,
      offset: filters.offset + filters.limit
    };
    return fetch('/web-api/v1/card-product/search', {
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    })
    .then(response => response.json())
    .then(json => dispatch(receiveMoreCards({ ...json, card_type: filters.card_type })))
    .catch(err => console.warn(err));
  }
);



// WEBPACK FOOTER //
// ./src/cards/actions/cardListingActions.js